import React, { useEffect, Suspense, lazy } from 'react';
import { HeroSection } from './components/HeroSection';
import { StickyBar } from './components/StickyBar';
import { ExitIntentPopup } from './components/ExitIntentPopup';
const PainSection = lazy(() => import('./components/PainSection').then(m => ({
  default: m.PainSection
})));
const MechanismSection = lazy(() => import('./components/MechanismSection').then(m => ({
  default: m.MechanismSection
})));
const OfferSection = lazy(() => import('./components/OfferSection').then(m => ({
  default: m.OfferSection
})));
const ObjectionsSection = lazy(() => import('./components/ObjectionsSection').then(m => ({
  default: m.ObjectionsSection
})));
const CTASection = lazy(() => import('./components/CTASection').then(m => ({
  default: m.CTASection
})));
const ClosingSection = lazy(() => import('./components/ClosingSection').then(m => ({
  default: m.ClosingSection
})));
export function App() {
  useEffect(() => {
    document.title = 'Audiobook Hábitos Atómicos Espirituales';
  }, []);
  return <div className="w-full min-h-screen bg-[#0f0529]" data-id="element-0">
      <HeroSection data-id="element-1" />
      <Suspense fallback={<div className="h-32" data-id="element-3" />} data-id="element-2">
        <PainSection data-id="element-4" />
        <MechanismSection data-id="element-5" />
        <OfferSection data-id="element-6" />
        <ObjectionsSection data-id="element-7" />
        <CTASection data-id="element-8" />
        <ClosingSection data-id="element-9" />
      </Suspense>
      <StickyBar data-id="element-10" />
      <ExitIntentPopup data-id="element-11" />
    </div>;
}